// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___YwMgq","sectionTitle":"sectionTitle___FFskf"};